var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSakigake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h802v602H-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "translate(-3.244 17.154) scale(.81874)",
    fontWeight: "bold",
    fontFamily: "Arvo, sans-serif",
    fontSize: 24,
    y: 0.082,
    x: 15.437,
    strokeWidth: 0,
    fill: "#FFD280"
  }, "{}"))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Zz4KICAgICAgICA8dGl0bGU+YmFja2dyb3VuZDwvdGl0bGU+CiAgICAgICAgPHJlY3QgZmlsbD0ibm9uZSIgaWQ9ImNhbnZhc19iYWNrZ3JvdW5kIiBoZWlnaHQ9IjYwMiIgd2lkdGg9IjgwMiIgeT0iLTEiIHg9Ii0xIi8+CiAgICA8L2c+CiAgICA8Zz4KICAgICAgICA8dGl0bGU+TGF5ZXIgMTwvdGl0bGU+CiAgICAgICAgPHRleHQgdHJhbnNmb3JtPSJtYXRyaXgoMC44MTg3NDEzMzc3MzYyMjM0LDAsMCwwLjgxODc0MTMzNzczNjIyMzQsLTMuMjQ0MjQ5MDI4ODU4ODMzLDE3LjE1MzcxNjU5MzE0OTcwNikgIiBmb250LXdlaWdodD0iYm9sZCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgdGV4dC1hbmNob3I9InN0YXJ0IiBmb250LWZhbWlseT0iQXJ2bywgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIyNCIgaWQ9InN2Z18yIiB5PSIwLjA4MjQyIiB4PSIxNS40Mzc0NSIgc3Ryb2tlLXdpZHRoPSIwIiBmaWxsPSIjRkZEMjgwIj57fTwvdGV4dD4KICAgIDwvZz4KPC9zdmc+";
export { SvgSakigake as ReactComponent };